import React, { Component } from 'react';
import { View, FlatList } from 'react-native';
import PropTypes from 'prop-types';
import UserNameComponent from 'modules/user/avatarbox.component';

export default class UserSearchComponent extends Component {
  static propTypes = {
    setSelected: PropTypes.func,
    users: PropTypes.array,
  };

  renderRow({ item }) {
    return (
      <View style={{ padding: 10, flex: 1 }}>
        <UserNameComponent user={item} setSelected={this.props.setSelected} />
      </View>
    );
  }

  render() {
    return (
      <FlatList
        automaticallyAdjustContentInsets={false}
        keyboardShouldPersistTaps={'always'}
        contentContainerStyle={{ backgroundColor: 'white' }}
        style={[{ flex: 1 }]}
        keyExtractor={(item) => item._id}
        data={this.props.users}
        renderItem={(rowData) => this.renderRow(rowData)}
      />
    );
  }
}
